import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setIsLoading(false); // Stop spinner after fetching data
    }, 1000);
  }, []);

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      {isLoading ? (
  <LoadingSpinner />
) : (
      <iframe
        src="https://www.spcommunity.org.za/delete-account"
        style={{ width: "100%", height: "1200px", border: "none" }}
        title="Contact Form"
        onLoad={() => setIsLoading(false)} // Hide spinner when iframe loads
      ></iframe>
       )}
    </div>
  );
};

export default ContactForm;
